import { useEffect, useState } from 'react';

import { isBrowser } from '@lucid/utils';

const useUrlParam = (paramName: string) => {
  const searchParams = isBrowser() ? window.location.search : '';
  const [paramValue, setParamValue] = useState(() => {
    const urlParams = new URLSearchParams(searchParams);

    return urlParams.get(paramName) || '';
  });

  useEffect(() => {
    const urlParams = new URLSearchParams(searchParams);
    const urlParamValue = urlParams.get(paramName) || '';

    if (urlParamValue !== paramValue) {
      setParamValue(urlParamValue);
    }
  }, [searchParams, paramName, paramValue]);

  return paramValue;
};

export default useUrlParam;
